import React from 'react';

const MinimalistGrid = () => {
  return (
    <div className="w-full h-full relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: 'linear-gradient(rgba(0, 255, 209, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 255, 209, 0.1) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
          animation: 'gridFadeIn 2s ease-in-out'
        }}
      />
      <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-[#00FFD1] rounded-full opacity-40 animate-pulse" />
      <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-[#00FFD1] rounded-full opacity-30 animate-pulse" style={{ animationDelay: '1s' }} />
      <div className="absolute bottom-1/3 left-1/2 w-1.5 h-1.5 bg-[#00FFD1] rounded-full opacity-35 animate-pulse" style={{ animationDelay: '2s' }} />
    </div>
  );
};

export default MinimalistGrid;